import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { enumErrorChannel, tokenRepository } from '../../repositories/token-repository';
import RequestProvider from 'domains/core-base/request/providers/request-provider';
import { AppContext } from 'domains/commons/contexts/global/global-provider';
import { existParamSolicitude } from 'domains/landing-autos/utils';
import {
  ACCESS_TOKEN_ACTION,
  REQUEST_ACTION,
} from 'domains/commons/contexts/global/staticData';
import { useNavigate, useParams } from 'react-router-dom';
import { getURLRedirectChannelPage } from 'libs/utils/redirectChannel';
import { getChannel } from 'libs/utils/routes';

type UseInitParameters = {
  recaptcha?: string;
  codApplication?: string;
  externalWeb?: boolean;
  isSolicitude?: boolean;
};

const useInitAuthentication = (data?: UseInitParameters) => {
  const requestInstance = RequestProvider.getInstance();
  const { actions, store } = useContext(AppContext);
  const navigate = useNavigate();
  const isSolicitude = existParamSolicitude();
  const { channel = null } = useParams();

  const validateRecaptchaExternalWeb = async () => {
    return tokenRepository.initApp({
      recaptcha: '',
      codApplication: 'AUTOS',
      externalWeb: store.externalWeb,
      isSolicitude: Boolean(isSolicitude),
      channel: getChannel(channel),
      ...data,
    });
  };

  return useQuery(['token'], async () => await validateRecaptchaExternalWeb(), {
    enabled: true,
    retry: false,
    onSuccess: (data) => {
      if (data) {
        if (data.responseChannel === enumErrorChannel.error) {
          const redirect = getURLRedirectChannelPage('principal');
          navigate(redirect);
          window.location.reload();
          return;
        }
        actions.dispatchAccessToken({
          type: ACCESS_TOKEN_ACTION.set,
          payload: data.token.access_token,
        });
        if (!isSolicitude) {
          actions.dispatchRequest({
            type: REQUEST_ACTION.set,
            payload: data.getRequest,
          });
          return requestInstance.saveRequestId(data.getRequest?.id as string);
        }
      }
    },
  });
};
export default useInitAuthentication;
